import { buildBookingUrl } from "./api";

export const todayPlusIso = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().split("T")[0];
};

// Micro rule engine: global settings < airline.offer_rules < destination.rules
export const resolveOfferRules = (settings, airline, dest) => ({
  days_ahead: 2,
  stay_days: 7,
  trip_type: "roundtrip",
  cabin: "Y",
  adult: 1,
  ...(settings
    ? {
        days_ahead: settings.offer_days_ahead ?? 2,
        stay_days: settings.offer_stay_days ?? 7,
        trip_type: settings.offer_trip_type || "roundtrip",
        cabin: settings.offer_cabin || "Y",
      }
    : {}),
  ...(airline?.offer_rules || {}),
  ...(dest?.rules || {}),
});

export const buildOfferLink = (settings, airline, dest) => {
  const r = resolveOfferRules(settings, airline, dest);
  const departDate = todayPlusIso(Number(r.days_ahead) || 2);
  return buildBookingUrl(settings?.booking_domain, {
    tripType: r.trip_type,
    dep: r.dep || airline.default_dep,
    ret: dest.code,
    departDate,
    returnDate: todayPlusIso((Number(r.days_ahead) || 2) + (Number(r.stay_days) || 7)),
    adult: r.adult || 1,
    child: 0,
    infant: 0,
    cabin: r.cabin || "Y",
    direct: !!r.direct,
    langcode: settings?.langcode || "EN",
  });
};
